import { render } from "./SoonSect.vue?vue&type=template&id=675bf63a&ts=true"
import script from "./SoonSect.vue?vue&type=script&lang=ts"
export * from "./SoonSect.vue?vue&type=script&lang=ts"

import "./SoonSect.vue?vue&type=style&index=0&id=675bf63a&lang=scss"

import exportComponent from "/Users/damodar/Documents/PROGRAMMING/STUDING/everypay/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__